// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://basescan.org/address/0x906B24a339b848369B24Dc9Ed368b947fB9693bf
export const sUSDS__USDS_Exchange_Rate = '0x906B24a339b848369B24Dc9Ed368b947fB9693bf';

// https://basescan.org/address/0x960BDD1dFD20d7c98fa482D793C3dedD73A113a3
export const ezETH__ETH = '0x960BDD1dFD20d7c98fa482D793C3dedD73A113a3';

// https://basescan.org/address/0x1a42ec779Ed3e5249d9b83Ad6B51492953080Ad9
export const SUSDAI__USDAI_Exchange_Rate = '0x1a42ec779Ed3e5249d9b83Ad6B51492953080Ad9';

// https://basescan.org/address/0x676C4C6C31D97A5581D3204C04A8125B350E2F9D
export const AXL__USD = '0x676C4C6C31D97A5581D3204C04A8125B350E2F9D';

// https://basescan.org/address/0xB88BAc61a4Ca37C43a3725912B1f472c9A5bc061
export const wstETH_stETH_Exchange_Rate = '0xB88BAc61a4Ca37C43a3725912B1f472c9A5bc061';

// https://basescan.org/address/0x8a55b7aB579321Eb1adb54Bc770308EA0378E287
export const AAVE_SVR_EURC__USD = '0x8a55b7aB579321Eb1adb54Bc770308EA0378E287';

// https://basescan.org/address/0x9867186e52d2F1C2c565CDA6E747101Fa56501e0
export const AAVE_SVR_EURC__USD_BASE = '0x9867186e52d2F1C2c565CDA6E747101Fa56501e0';

// https://basescan.org/address/0xD89c7fFB39C44b17EAecd8717a75A36c19C07582
export const sUSDz__USDz_Exchange_Rate = '0xD89c7fFB39C44b17EAecd8717a75A36c19C07582';

// https://basescan.org/address/0xe96EB1EDa83d18cbac224233319FA5071464e1b9
export const wOETH__OETH_Exchange_Rate = '0xe96EB1EDa83d18cbac224233319FA5071464e1b9';

// https://basescan.org/address/0x806b4Ac04501c29769051e42783cF04dCE41440b
export const CBETH__ETH = '0x806b4Ac04501c29769051e42783cF04dCE41440b';

// https://basescan.org/address/0x0b0E64c05083FdF9ED7C5D3d8262c4216eFc9394
export const BRL__USD = '0x0b0E64c05083FdF9ED7C5D3d8262c4216eFc9394';

// https://basescan.org/address/0x6D75BFB5A5885f841b132198C9f0bE8c872057BF
export const TBTC__USD = '0x6D75BFB5A5885f841b132198C9f0bE8c872057BF';

// https://basescan.org/address/0x9e07546c9Fe8868855CD04B26051a26D1599E270
export const LBTC__USD = '0x9e07546c9Fe8868855CD04B26051a26D1599E270';

// https://basescan.org/address/0x7e860098F58bBFC8648a4311b374B1D669a2bc6B
export const USDC__USD = '0x7e860098F58bBFC8648a4311b374B1D669a2bc6B';

// https://basescan.org/address/0xEf2E24ba6def99B5e0b71F6CDeaF294b02163094
export const RDNT__USD = '0xEf2E24ba6def99B5e0b71F6CDeaF294b02163094';

// https://basescan.org/address/0x4a595E0a62E50A2E5eC95A70c8E612F9746af006
export const USR__USD = '0x4a595E0a62E50A2E5eC95A70c8E612F9746af006';

// https://basescan.org/address/0x1550207eAeB590D1557a6E6C066D3d57B5A4Dc65
export const AAVE_SVR_USDC__USD = '0x1550207eAeB590D1557a6E6C066D3d57B5A4Dc65';

// https://basescan.org/address/0x458138Fc0D67027E9A6778ef40a6ffC318c69061
export const AAVE_SVR_USDC__USD_BASE = '0x458138Fc0D67027E9A6778ef40a6ffC318c69061';

// https://basescan.org/address/0x311D3A3faA1d5939c681E33C2CDAc041FF388EB2
export const syrupUSDC_USDC_Exchange_Rate = '0x311D3A3faA1d5939c681E33C2CDAc041FF388EB2';

// https://basescan.org/address/0x2ecc8A8B370fC6a217166b2782a35339bEBEe98B
export const ZAR__USD = '0x2ecc8A8B370fC6a217166b2782a35339bEBEe98B';

// https://basescan.org/address/0xEEe1a9D5A0C36d99972C057Cb959267e88Ab9160
export const CBXRP__USD = '0xEEe1a9D5A0C36d99972C057Cb959267e88Ab9160';

// https://basescan.org/address/0x81575495532fB311Efc5C993B612564274F0949b
export const SGD__USD = '0x81575495532fB311Efc5C993B612564274F0949b';

// https://basescan.org/address/0x3A932b286715abc4A86a4ACAF68A6cdD89E0d446
export const AAVE_SVR_BTC__USD = '0x3A932b286715abc4A86a4ACAF68A6cdD89E0d446';

// https://basescan.org/address/0x32F587986D3fb47601157c19615d568BeD0BCabc
export const AAVE_SVR_BTC__USD_BASE = '0x32F587986D3fb47601157c19615d568BeD0BCabc';

// https://basescan.org/address/0x8004571d9f54dE016fc3D448e7AEe2d70947727A
export const tETH__wstETH_Exchange_Rate = '0x8004571d9f54dE016fc3D448e7AEe2d70947727A';

// https://basescan.org/address/0x83ac12dBb5Bd7Fa597ab2FFEc9F2F13DeDdFe163
export const inETH__ETH_Exchange_Rate = '0x83ac12dBb5Bd7Fa597ab2FFEc9F2F13DeDdFe163';

// https://basescan.org/address/0x868a501e68F3D1E89CfC0D22F6b22E8dabce5F04
export const cbETH_ETH_Exchange_Rate = '0x868a501e68F3D1E89CfC0D22F6b22E8dabce5F04';

// https://basescan.org/address/0x35e9D7001819Ea3B39Da906aE6b06A62cfe2c181
export const weETH__eETH_Exchange_Rate = '0x35e9D7001819Ea3B39Da906aE6b06A62cfe2c181';

// https://basescan.org/address/0xb4482096e3cdE116C15fC0D700a73a58FEdeB8c0
export const ynETH__ETH_Exchange_Rate = '0xb4482096e3cdE116C15fC0D700a73a58FEdeB8c0';

// https://basescan.org/address/0x591e79239a7d679378eC8c847e5038150364C78F
export const DAI__USD = '0x591e79239a7d679378eC8c847e5038150364C78F';

// https://basescan.org/address/0xe8dD07CCf5BC4922424140E44Eb970F5950725ef
export const wrsETH_ETH_Exchange_Rate = '0xe8dD07CCf5BC4922424140E44Eb970F5950725ef';

// https://basescan.org/address/0xC4300B7CF0646F0Fe4C5B2ACFCCC4dCA1346f5d8
export const ezETH__ETH_Exchange_Rate = '0xC4300B7CF0646F0Fe4C5B2ACFCCC4dCA1346f5d8';

// https://basescan.org/address/0x237A94A589DD38DF7e50CeFDa0b8916a54d01ecC
export const XDC__USD = '0x237A94A589DD38DF7e50CeFDa0b8916a54d01ecC';

// https://basescan.org/address/0x3E3A6bD129A63564FE7abde85FA67c3950569060
export const OP__USD = '0x3E3A6bD129A63564FE7abde85FA67c3950569060';

// https://basescan.org/address/0xdfbb5Cbc88E382de007bfe6CE99C388176ED80aD
export const NGN__USD = '0xdfbb5Cbc88E382de007bfe6CE99C388176ED80aD';

// https://basescan.org/address/0xc5E65227fe3385B88468F9A01600017cDC9F3A12
export const LINK__ETH = '0xc5E65227fe3385B88468F9A01600017cDC9F3A12';

// https://basescan.org/address/0x4aEE0164400FE35B6b400F2d767A618Bcb96a02D
export const DOLA__USD = '0x4aEE0164400FE35B6b400F2d767A618Bcb96a02D';

// https://basescan.org/address/0x790181e93e9F4Eedb5b864860C12e4d2CffFe73B
export const USDe__USD = '0x790181e93e9F4Eedb5b864860C12e4d2CffFe73B';

// https://basescan.org/address/0x0396000dc82bfAEe746A9Ac6dC69dAd3223Ca9c6
export const PHP__USD = '0x0396000dc82bfAEe746A9Ac6dC69dAd3223Ca9c6';

// https://basescan.org/address/0x65623109aA4561AD3cfF503542083548CeD7e085
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Level =
  '0x65623109aA4561AD3cfF503542083548CeD7e085';

// https://basescan.org/address/0x2330aaE3bca5F05169d5f4597964D44522F62930
export const USDS__USD = '0x2330aaE3bca5F05169d5f4597964D44522F62930';

// https://basescan.org/address/0xd7818272B9e248357d13057AAb0B417aF31E817d
export const CBETH__USD = '0xd7818272B9e248357d13057AAb0B417aF31E817d';

// https://basescan.org/address/0x311681f6E0b34670Fb03e066cc08C6D09149a44c
export const WMTx__USD = '0x311681f6E0b34670Fb03e066cc08C6D09149a44c';

// https://basescan.org/address/0xb58c5C550Ba19c4CEeE071F8CeeB58f8770e6978
export const inwstETH__wstETH_Exchange_Rate = '0xb58c5C550Ba19c4CEeE071F8CeeB58f8770e6978';

// https://basescan.org/address/0x491a921c41d6a97C57426E0c0108a231cd6E5f60
export const SUI__USD = '0x491a921c41d6a97C57426E0c0108a231cd6E5f60';

// https://basescan.org/address/0x5213eBB69743b85644dbB6E25cdF994aFBb8cF31
export const XAU__USD = '0x5213eBB69743b85644dbB6E25cdF994aFBb8cF31';

// https://basescan.org/address/0xCceA6576904C118037695eB71195a5425E69Fa15
export const GBP__USD = '0xCceA6576904C118037695eB71195a5425E69Fa15';

// https://basescan.org/address/0xc1a849217F3BaB97F1a46b990e369D6705B4be96
export const yUSD__USD_Exchange_Rate = '0xc1a849217F3BaB97F1a46b990e369D6705B4be96';

// https://basescan.org/address/0x2B1de6AD89847C11aF2ede14edB013AA79E94aC9
export const MAG7SSI__USD = '0x2B1de6AD89847C11aF2ede14edB013AA79E94aC9';

// https://basescan.org/address/0xB366E8Efb9661323ff477CedF70f55F897D6cFeA
export const ARKB_Reserves = '0xB366E8Efb9661323ff477CedF70f55F897D6cFeA';

// https://basescan.org/address/0x0F8E057D1D7b282EF968D26E9cB432617dF52519
export const cbBTC_Reserves = '0x0F8E057D1D7b282EF968D26E9cB432617dF52519';

// https://basescan.org/address/0xf397bF97280B488cA19ee3093E81C0a77F02e9a5
export const RETH__ETH = '0xf397bF97280B488cA19ee3093E81C0a77F02e9a5';

// https://basescan.org/address/0xa669E5272E60f78299F4824495cE01a3923f4380
export const wstETH_ETH_Exchange_Rate = '0xa669E5272E60f78299F4824495cE01a3923f4380';

// https://basescan.org/address/0xFC1415403EbB0c693f9a7844b92aD2Ff24775C65
export const weETH__ETH = '0xFC1415403EbB0c693f9a7844b92aD2Ff24775C65';

// https://basescan.org/address/0xd7221b10FBBC1e1ba95Fd0B4D031C15f7F365296
export const RSETH__ETH = '0xd7221b10FBBC1e1ba95Fd0B4D031C15f7F365296';

// https://basescan.org/address/0xc91D87E81faB8f93699ECf7Ee9B44D11e1D53F0F
export const EUR__USD = '0xc91D87E81faB8f93699ECf7Ee9B44D11e1D53F0F';

// https://basescan.org/address/0xAAEbc0287EC3BF3fe56fCA1E4bcC793b219De551
export const AAVE_SVR_AAVE__USD = '0xAAEbc0287EC3BF3fe56fCA1E4bcC793b219De551';

// https://basescan.org/address/0x65B5d02E1Fff839b8B67Fa26F8540e5f11454316
export const AAVE_SVR_AAVE__USD_BASE = '0x65B5d02E1Fff839b8B67Fa26F8540e5f11454316';

// https://basescan.org/address/0x0594c1a01375c1151c2ca78BE4870836EbFA9846
export const wstUSR__stUSR_Exchange_Rate = '0x0594c1a01375c1151c2ca78BE4870836EbFA9846';

// https://basescan.org/address/0x07DA0E54543a844a80ABE69c8A12F22B3aA59f9D
export const cbBTC__USD = '0x07DA0E54543a844a80ABE69c8A12F22B3aA59f9D';

// https://basescan.org/address/0x18A3fcA54FaC5B05837205bA4b823fc56191F793
export const PCE_Price_Index_Level = '0x18A3fcA54FaC5B05837205bA4b823fc56191F793';

// https://basescan.org/address/0x30A76F4E688Cf52f4A06D7AAd987A7037f3Ae6f7
export const dlcBTC_Proof_of_Reserves = '0x30A76F4E688Cf52f4A06D7AAd987A7037f3Ae6f7';

// https://basescan.org/address/0x9f0C1dD78C4CBdF5b9cf923a549A201EdC676D34
export const XRP__USD = '0x9f0C1dD78C4CBdF5b9cf923a549A201EdC676D34';

// https://basescan.org/address/0x91D7AEd72bF772A0DA30199B925aCB866ACD3D9e
export const OGN__USD = '0x91D7AEd72bF772A0DA30199B925aCB866ACD3D9e';

// https://basescan.org/address/0x1E6A29666288a310326B37d823Fe4Ea3937424D2
export const rETH__ETH_Exchange_Rate = '0x1E6A29666288a310326B37d823Fe4Ea3937424D2';

// https://basescan.org/address/0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70
export const ETH__USD = '0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70';

// https://basescan.org/address/0x05A6cF213EcC5501A11a08EBefA4A8a60313ef97
export const IDR__USD = '0x05A6cF213EcC5501A11a08EBefA4A8a60313ef97';

// https://basescan.org/address/0x29413773e7CD4Dfd6Ad89a50887877b88a6C592C
export const TRY__USD = '0x29413773e7CD4Dfd6Ad89a50887877b88a6C592C';

// https://basescan.org/address/0x1Eba1d6941088c8FCE2CbcaC80754C77871aD093
export const sfrxETH_frxETH_Exchange_Rate = '0x1Eba1d6941088c8FCE2CbcaC80754C77871aD093';

// https://basescan.org/address/0xBCF85224fc0756B9Fa45aA7892530B47e10b6433
export const L2_Sequencer_Uptime_Status_Feed = '0xBCF85224fc0756B9Fa45aA7892530B47e10b6433';

// https://basescan.org/address/0x9DDa783DE64A9d1A60c49ca761EbE528C35BA428
export const COMP__USD = '0x9DDa783DE64A9d1A60c49ca761EbE528C35BA428';

// https://basescan.org/address/0x206a34e47093125fbf4C75b7c7E88b84c6A77a69
export const LTC__USD = '0x206a34e47093125fbf4C75b7c7E88b84c6A77a69';

// https://basescan.org/address/0x4F2fe331C8EB0fb8A84A4d893C87Cf28A36Ab093
export const ARSx_Proof_of_Reserves = '0x4F2fe331C8EB0fb8A84A4d893C87Cf28A36Ab093';

// https://basescan.org/address/0x99C098FA069B120dd81E56c0f2178093cc7a851f
export const vyUSD_USD_Exchange_Rate = '0x99C098FA069B120dd81E56c0f2178093cc7a851f';

// https://basescan.org/address/0x79cf4a31B29D69191f0b6E97916eB93FEB81E533
export const sUSDe__USD = '0x79cf4a31B29D69191f0b6E97916eB93FEB81E533';

// https://basescan.org/address/0xd8CA171B6f0F6B2a01B6B2dB7424dd72AA07a6F1
export const AAVE_SVR_GHO__USD = '0xd8CA171B6f0F6B2a01B6B2dB7424dd72AA07a6F1';

// https://basescan.org/address/0x1B5FEF61Ff9B690364359b03cC07E060b12Bd3C1
export const AAVE_SVR_GHO__USD_BASE = '0x1B5FEF61Ff9B690364359b03cC07E060b12Bd3C1';

// https://basescan.org/address/0x46e51B8cA41d709928EdA9Ae43e42193E6CDf229
export const AUD__USD = '0x46e51B8cA41d709928EdA9Ae43e42193E6CDf229';

// https://basescan.org/address/0x807f6Da67498aE4185Cd45deaB9e803eDDd151bf
export const AAVE_SVR_WEETH__EETH_Exchange_Rate = '0x807f6Da67498aE4185Cd45deaB9e803eDDd151bf';

// https://basescan.org/address/0xd71cdcAaea1Ce61146CD7257BE65412007a62819
export const AAVE_SVR_WEETH__EETH_Exchange_Rate_BASE = '0xd71cdcAaea1Ce61146CD7257BE65412007a62819';

// https://basescan.org/address/0x674940e1dBf7FD841b33156DA9A88afbD95AaFBa
export const WIF__USD = '0x674940e1dBf7FD841b33156DA9A88afbD95AaFBa';

// https://basescan.org/address/0x63Af8341b62E683B87bB540896bF283D96B4D385
export const STG__USD = '0x63Af8341b62E683B87bB540896bF283D96B4D385';

// https://basescan.org/address/0x962C0Df8Ca7f7C682B3872ccA31Ea9c8999ab23c
export const Total_Market_Cap_USD = '0x962C0Df8Ca7f7C682B3872ccA31Ea9c8999ab23c';

// https://basescan.org/address/0x3d6774EF702A10b20FCa8Ed40FC022f7E4938e07
export const AAVE__USD = '0x3d6774EF702A10b20FCa8Ed40FC022f7E4938e07';

// https://basescan.org/address/0x1Bb54D3d4edBB52B83BC89Da5B176Facc90D46bc
export const ccUSDC__USDC_Exchange_Rate = '0x1Bb54D3d4edBB52B83BC89Da5B176Facc90D46bc';

// https://basescan.org/address/0x17CAb8FE31E32f08326e5E27412894e49B0f9D65
export const LINK__USD = '0x17CAb8FE31E32f08326e5E27412894e49B0f9D65';

// https://basescan.org/address/0x17738F7dacFc1De7d06f22cC52211EBf68744dBA
export const xSolvBTC_NAV = '0x17738F7dacFc1De7d06f22cC52211EBf68744dBA';

// https://basescan.org/address/0xe3971Ed6F1A5903321479Ef3148B5950c0612075
export const SNX__USD = '0xe3971Ed6F1A5903321479Ef3148B5950c0612075';

// https://basescan.org/address/0x8eC6a128a430f7A850165bcF18facc9520a9873F
export const VVV__USD = '0x8eC6a128a430f7A850165bcF18facc9520a9873F';

// https://basescan.org/address/0x5E988c11a4f92155C30D9fb69Ed75597f712B113
export const POL__USD = '0x5E988c11a4f92155C30D9fb69Ed75597f712B113';

// https://basescan.org/address/0x1688e4B274a4CC9fD398EbA6Ae4dfb6528A9D2bc
export const AMP__USD = '0x1688e4B274a4CC9fD398EbA6Ae4dfb6528A9D2bc';

// https://basescan.org/address/0xf586d0728a47229e747d824a939000Cf21dEF5A0
export const STETH__ETH = '0xf586d0728a47229e747d824a939000Cf21dEF5A0';

// https://basescan.org/address/0x1401Fd60F9ba4F718a2fE6149aadf3d1F0dB1b0A
export const SVR_USDC__USD = '0x1401Fd60F9ba4F718a2fE6149aadf3d1F0dB1b0A';

// https://basescan.org/address/0xd0Dc8c910565D94D408729D16bE5467B5d7633Ad
export const SVR_USDC__USD_BASE = '0xd0Dc8c910565D94D408729D16bE5467B5d7633Ad';

// https://basescan.org/address/0xbb9786e37D54251477EbC1325b04ACdCA18C2254
export const ultraETHs__ETH_Exchange_Rate = '0xbb9786e37D54251477EbC1325b04ACdCA18C2254';

// https://basescan.org/address/0xd9c5B59A913d75AC44EB51b7E0F3f5B58816ECAc
export const AAVE_Network_Emergency_Count_Base = '0xd9c5B59A913d75AC44EB51b7E0F3f5B58816ECAc';

// https://basescan.org/address/0xdEd37FC1400B8022968441356f771639ad1B23aA
export const sUSDe__USDe_Exchange_Rate = '0xdEd37FC1400B8022968441356f771639ad1B23aA';

// https://basescan.org/address/0xB48ac6409C0c3718b956089b0fFE295A10ACDdad
export const PEPE__USD = '0xB48ac6409C0c3718b956089b0fFE295A10ACDdad';

// https://basescan.org/address/0xA840145F87572E82519d578b1F36340368a25D5d
export const CAD__USD = '0xA840145F87572E82519d578b1F36340368a25D5d';

// https://basescan.org/address/0x9FB8b5A4b3FE655564f0c76616ae79DE90Cc7382
export const MEW__USD = '0x9FB8b5A4b3FE655564f0c76616ae79DE90Cc7382';

// https://basescan.org/address/0x1428C9E908e32dD2839F99D63C242c91329A58C0
export const SVR_ETH__USD = '0x1428C9E908e32dD2839F99D63C242c91329A58C0';

// https://basescan.org/address/0x5731Ae06077c79A3B292498940211E0aE7130bd3
export const SVR_ETH__USD_BASE = '0x5731Ae06077c79A3B292498940211E0aE7130bd3';

// https://basescan.org/address/0xE70f2D34Fd04046aaEC26a198A35dD8F2dF5cd92
export const AVAX__USD = '0xE70f2D34Fd04046aaEC26a198A35dD8F2dF5cd92';

// https://basescan.org/address/0x64c911996D3c6aC71f9b455B1E8E7266BcbD848F
export const BTC__USD = '0x64c911996D3c6aC71f9b455B1E8E7266BcbD848F';

// https://basescan.org/address/0x121934C415937863d64ef93436169444633EE0d8
export const HOME__USD = '0x121934C415937863d64ef93436169444633EE0d8';

// https://basescan.org/address/0x9C6BF4884Ff0c7873652F7d5142FA3b9859a526D
export const instETH__ETH_Exchange_Rate = '0x9C6BF4884Ff0c7873652F7d5142FA3b9859a526D';

// https://basescan.org/address/0xA6E3b91196afC536E4944B78aBb7DA41E7e18d6b
export const AAVE_SVR_LBTC__BTC_Exchange_Rate = '0xA6E3b91196afC536E4944B78aBb7DA41E7e18d6b';

// https://basescan.org/address/0xBf4892f41c753c5E1b03e8a7B425bd2679a6C224
export const AAVE_SVR_LBTC__BTC_Exchange_Rate_BASE = '0xBf4892f41c753c5E1b03e8a7B425bd2679a6C224';

// https://basescan.org/address/0x90F3676B40F6dc2C1E074985D0544Bb8e1815B00
export const CTX__USD = '0x90F3676B40F6dc2C1E074985D0544Bb8e1815B00';

// https://basescan.org/address/0x1E6c22AAA11F507af12034A5Dc4126A6A25DC8d2
export const LBTC__BTC = '0x1E6c22AAA11F507af12034A5Dc4126A6A25DC8d2';

// https://basescan.org/address/0xaE95742Cf839529798Bcd1610c6E0AFEBA0cBC03
export const YETH_ETH_Exchange_Rate = '0xaE95742Cf839529798Bcd1610c6E0AFEBA0cBC03';

// https://basescan.org/address/0x42868EFcee13C0E71af89c04fF7d96f5bec479b0
export const GHO__USD = '0x42868EFcee13C0E71af89c04fF7d96f5bec479b0';

// https://basescan.org/address/0x34cD971a092d5411bD69C10a5F0A7EEF72C69041
export const ADA__USD = '0x34cD971a092d5411bD69C10a5F0A7EEF72C69041';

// https://basescan.org/address/0x2d4b8B1083a7C278B4C45c598De155e5f9b7A8D5
export const AAVE_SVR_WSTETH__STETH_Exchange_Rate = '0x2d4b8B1083a7C278B4C45c598De155e5f9b7A8D5';

// https://basescan.org/address/0xfd14a390149e23F972AbC9B7E31d3B1fdf508B38
export const AAVE_SVR_WSTETH__STETH_Exchange_Rate_BASE =
  '0xfd14a390149e23F972AbC9B7E31d3B1fdf508B38';

// https://basescan.org/address/0xd5Ec94430eF4170D819E0996BC53ed40d31638d8
export const USDPlus__USD = '0xd5Ec94430eF4170D819E0996BC53ed40d31638d8';

// https://basescan.org/address/0xC8D5D660bb585b68fa0263EeD7B4224a5FC99669
export const SHIB__USD = '0xC8D5D660bb585b68fa0263EeD7B4224a5FC99669';

// https://basescan.org/address/0x0E230b1077c663f8Fb5e68d84A8e3e33D97d7436
export const OUSDT__USD = '0x0E230b1077c663f8Fb5e68d84A8e3e33D97d7436';

// https://basescan.org/address/0x979447581b39caCA33EF0CA8208592393D16cc13
export const MAVIA__USD = '0x979447581b39caCA33EF0CA8208592393D16cc13';

// https://basescan.org/address/0xB5DD7388a9cE094dAde71bB1Dd32dCE68dA8Ac30
export const AAVE_SVR_EZETH__ETH_Exchange_Rate = '0xB5DD7388a9cE094dAde71bB1Dd32dCE68dA8Ac30';

// https://basescan.org/address/0x442f870a32Ea74C1A4630f7Dc357F8aBd552eF37
export const AAVE_SVR_EZETH__ETH_Exchange_Rate_BASE = '0x442f870a32Ea74C1A4630f7Dc357F8aBd552eF37';

// https://basescan.org/address/0x97b770B0200CCe161907a9cbe0C6B177679f8F7C
export const rswETH__ETH_Exchange_Rate = '0x97b770B0200CCe161907a9cbe0C6B177679f8F7C';

// https://basescan.org/address/0xEaf310161c9eF7c813A14f8FEF6Fb271434019F7
export const VIRTUAL__USD = '0xEaf310161c9eF7c813A14f8FEF6Fb271434019F7';

// https://basescan.org/address/0xdc31a4CCfCA039BeC6222e20BE7770E12581bfEB
export const ZRO__USD = '0xdc31a4CCfCA039BeC6222e20BE7770E12581bfEB';

// https://basescan.org/address/0x43a5C292A453A3bF3606fa856197f09D7B74251a
export const WSTETH__ETH = '0x43a5C292A453A3bF3606fa856197f09D7B74251a';

// https://basescan.org/address/0x39C6E14CdE46D4FFD9F04Ff159e7ce8eC20E10B4
export const SUPEROETHB__ETH = '0x39C6E14CdE46D4FFD9F04Ff159e7ce8eC20E10B4';

// https://basescan.org/address/0x203e994f3908cF886C6155c31742557D82c9B4a2
export const AAVE_SVR_USDT__USD = '0x203e994f3908cF886C6155c31742557D82c9B4a2';

// https://basescan.org/address/0xE5fa3A4e4208858ADdf2CDb4e12651E89f1f1A70
export const AAVE_SVR_USDT__USD_BASE = '0xE5fa3A4e4208858ADdf2CDb4e12651E89f1f1A70';

// https://basescan.org/address/0xbC7c5023eE571e4D9C4890C90a16be05c1EEf410
export const uniBTC__BTC_Exchange_Rate = '0xbC7c5023eE571e4D9C4890C90a16be05c1EEf410';

// https://basescan.org/address/0x88a98431C25329AA422B21D147c1518b34dD36F4
export const APT__USD = '0x88a98431C25329AA422B21D147c1518b34dD36F4';

// https://basescan.org/address/0x67283A47E470afbCcc4aC74ccC32401a81027691
export const SolvBTCBBN__SolvBTC_Exchange_Rate = '0x67283A47E470afbCcc4aC74ccC32401a81027691';

// https://basescan.org/address/0x122b5334A8b55861dBc6729c294451471FbF318D
export const MLN__USD = '0x122b5334A8b55861dBc6729c294451471FbF318D';

// https://basescan.org/address/0x4EC5970fC728C5f65ba413992CD5fF6FD70fcfF0
export const AERO__USD = '0x4EC5970fC728C5f65ba413992CD5fF6FD70fcfF0';

// https://basescan.org/address/0x0b68ac37a1668DAaab1882543368E076C38C40e9
export const TETH_Reserves = '0x0b68ac37a1668DAaab1882543368E076C38C40e9';

// https://basescan.org/address/0x3A1d6444fb6a402470098E23DaD0B7E86E14252F
export const CHF__USD = '0x3A1d6444fb6a402470098E23DaD0B7E86E14252F';

// https://basescan.org/address/0xe0eda54fC1362C0d7d0ff855E4fCEA79916Fe094
export const Real_GDP_Percent_Change_Annual_Rate = '0xe0eda54fC1362C0d7d0ff855E4fCEA79916Fe094';

// https://basescan.org/address/0x4e7dB2f9a28348AB48a968dd4217D565D1F15Ba4
export const ynETHx__ETH_Exchange_Rate = '0x4e7dB2f9a28348AB48a968dd4217D565D1F15Ba4';

// https://basescan.org/address/0x0df397aFE00085C138a99eFB39C498e08eB95aD1
export const Real_GDP_Level = '0x0df397aFE00085C138a99eFB39C498e08eB95aD1';

// https://basescan.org/address/0x2a18E2d46Cb067b69e0759dB39b16597fC42D962
export const PCE_Price_Index_Percent_Change_Annual_Rate =
  '0x2a18E2d46Cb067b69e0759dB39b16597fC42D962';

// https://basescan.org/address/0x1fC950BbC12E93c15A3eEb62db978eb3cC567943
export const SYND__USD = '0x1fC950BbC12E93c15A3eEb62db978eb3cC567943';

// https://basescan.org/address/0xeDC243c7E3c1A9dAf067C90641D2346d2694d2e5
export const LSETH__ETH = '0xeDC243c7E3c1A9dAf067C90641D2346d2694d2e5';

// https://basescan.org/address/0xe25969e2Fa633a0C027fAB8F30Fc9C6A90D60B48
export const USDz__USD = '0xe25969e2Fa633a0C027fAB8F30Fc9C6A90D60B48';

// https://basescan.org/address/0x5218Ebeb96bD2bAFe21F9b143f5672552629ba79
export const USDO_Reserves = '0x5218Ebeb96bD2bAFe21F9b143f5672552629ba79';

// https://basescan.org/address/0x9dA00D23465282005DB222a441a663eE7B9dfCc8
export const AAVE_SVR_ETH__USD = '0x9dA00D23465282005DB222a441a663eE7B9dfCc8';

// https://basescan.org/address/0xa4250cE1aA15Ff4cb5E5a8655293b65694e436Ed
export const AAVE_SVR_ETH__USD_BASE = '0xa4250cE1aA15Ff4cb5E5a8655293b65694e436Ed';

// https://basescan.org/address/0xe95e258bb6615d47515Fc849f8542dA651f12bF6
export const MORPHO__USD = '0xe95e258bb6615d47515Fc849f8542dA651f12bF6';

// https://basescan.org/address/0xf19d560eB8d2ADf07BD6D13ed03e1D11215721F9
export const USDT__USD = '0xf19d560eB8d2ADf07BD6D13ed03e1D11215721F9';

// https://basescan.org/address/0xCCADC697c55bbB68dc5bCdf8d3CBe83CdD4E071E
export const WBTC__USD = '0xCCADC697c55bbB68dc5bCdf8d3CBe83CdD4E071E';

// https://basescan.org/address/0xeF7541b388a77C1709a3d44BfBfC5c1ED3F0Ac94
export const MAMO__USD = '0xeF7541b388a77C1709a3d44BfBfC5c1ED3F0Ac94';

// https://basescan.org/address/0x975043adBb80fc32276CbF9Bbcfd4A601a12462D
export const SOL__USD = '0x975043adBb80fc32276CbF9Bbcfd4A601a12462D';

// https://basescan.org/address/0x69a1d14a4e58e97EDE8337DE61eEB2e4a55886E0
export const pufETH__ETH_Exchange_Rate = '0x69a1d14a4e58e97EDE8337DE61eEB2e4a55886E0';

// https://basescan.org/address/0x7bAfa1Af54f17cC0775a1Cf813B9fF5dED2C51E5
export const TRUMP__USD = '0x7bAfa1Af54f17cC0775a1Cf813B9fF5dED2C51E5';

// https://basescan.org/address/0xFCb2C36ac8A91cE9D3c94590ED239E1f683467fe
export const USDAI__USD = '0xFCb2C36ac8A91cE9D3c94590ED239E1f683467fe';

// https://basescan.org/address/0x721F1B4dc604AEA0661Aa9982AB624e5756B31f2
export const mooBIFI__USD = '0x721F1B4dc604AEA0661Aa9982AB624e5756B31f2';

// https://basescan.org/address/0x95Eba7bE2f755a298984bd714822994f1d4B6313
export const YBTC_BTC_Exchange_Rate = '0x95Eba7bE2f755a298984bd714822994f1d4B6313';

// https://basescan.org/address/0x8422f3d3CAFf15Ca682939310d6A5e619AE08e57
export const DOGE__USD = '0x8422f3d3CAFf15Ca682939310d6A5e619AE08e57';

// https://basescan.org/address/0xf488FA1B4Ac8210bf0b2d212176ca28c48F86708
export const GLDY_Reserves = '0xf488FA1B4Ac8210bf0b2d212176ca28c48F86708';

// https://basescan.org/address/0xFAf372CaBc765b63f6fabD436c845D965eDA1CA5
export const MELANIA__USD = '0xFAf372CaBc765b63f6fabD436c845D965eDA1CA5';

// https://basescan.org/address/0x7FCED5198e43ec93Ef2179DFC70a8dcf494DcB80
export const iBTC_Proof_of_Reserves = '0x7FCED5198e43ec93Ef2179DFC70a8dcf494DcB80';

// https://basescan.org/address/0xB4a1a7f260C9FF7fEd6A6fbb9fe5a9acFa725DBf
export const solvBTC__BTC = '0xB4a1a7f260C9FF7fEd6A6fbb9fe5a9acFa725DBf';

// https://basescan.org/address/0x2C33efee59abFcc3612B60B7a78bdc2CDd8797d1
export const SVR_EURC__USD = '0x2C33efee59abFcc3612B60B7a78bdc2CDd8797d1';

// https://basescan.org/address/0xa25cBF938Ace4b219a9d012971c7b4e898EF6c68
export const SVR_EURC__USD_BASE = '0xa25cBF938Ace4b219a9d012971c7b4e898EF6c68';

// https://basescan.org/address/0xE62BcE5D7CB9d16AB8b4D622538bc0A50A5799c2
export const DEGEN__USD = '0xE62BcE5D7CB9d16AB8b4D622538bc0A50A5799c2';

// https://basescan.org/address/0x9e8Ee77c76d4fa41306056D1C3196AF5da1600bd
export const MXN__USD = '0x9e8Ee77c76d4fa41306056D1C3196AF5da1600bd';

// https://basescan.org/address/0x4b7836916781CAAfbb7Bd1E5FDd20ED544B453b1
export const BNB__USD = '0x4b7836916781CAAfbb7Bd1E5FDd20ED544B453b1';

// https://basescan.org/address/0x99DAf760d2CFB770cc17e883dF45454FE421616b
export const rsETH__ETH_Exchange_Rate = '0x99DAf760d2CFB770cc17e883dF45454FE421616b';

// https://basescan.org/address/0x95051De9Db5Cac61682f64505006f2991dEaB3c2
export const CBDOGE__USD = '0x95051De9Db5Cac61682f64505006f2991dEaB3c2';

// https://basescan.org/address/0xDAe398520e2B67cd3f27aeF9Cf14D93D927f8250
export const EURC__USD = '0xDAe398520e2B67cd3f27aeF9Cf14D93D927f8250';

// https://basescan.org/address/0xc15d9944dAefE2dB03e53bef8DDA25a56832C5fe
export const WELL__USD = '0xc15d9944dAefE2dB03e53bef8DDA25a56832C5fe';

// https://basescan.org/address/0xb4b7ac939fB1ABA057D70Eb070254503777D8b1c
export const SVR_USDT__USD = '0xb4b7ac939fB1ABA057D70Eb070254503777D8b1c';

// https://basescan.org/address/0xE6c6bf78308C46bad5Cae5D0ed44b36370b4B00d
export const SVR_USDT__USD_BASE = '0xE6c6bf78308C46bad5Cae5D0ed44b36370b4B00d';

// https://basescan.org/address/0xBbdA526258856c06f167399097e13D79E8f88ba8
export const CUSDO__USD = '0xBbdA526258856c06f167399097e13D79E8f88ba8';

// https://basescan.org/address/0xD40e758b5eC80820B68DFC302fc5Ce1239083548
export const YFI__USD = '0xD40e758b5eC80820B68DFC302fc5Ce1239083548';

// https://basescan.org/address/0xe2b3688371130f333443428Cf03f27Ce0378F9dC
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Percent_Change_Annual_Rate =
  '0xe2b3688371130f333443428Cf03f27Ce0378F9dC';

// https://basescan.org/address/0x06bdFe07E71C476157FC025d3cCD4BBe08e83EF9
export const NZD__USD = '0x06bdFe07E71C476157FC025d3cCD4BBe08e83EF9';

// https://basescan.org/address/0x50997b806B574501cC34a2a6d845e4dc1Bd9Aa8c
export const AVNT__USD = '0x50997b806B574501cC34a2a6d845e4dc1Bd9Aa8c';

// https://basescan.org/address/0x4aeb6D15769EaD32D0c5Be2940F40c7CFf53801d
export const MOG__USD = '0x4aeb6D15769EaD32D0c5Be2940F40c7CFf53801d';

// https://basescan.org/address/0x03Df23A32C83cA8cD9B1aAC0aF1c72924af7502b
export const SVR_BTC__USD = '0x03Df23A32C83cA8cD9B1aAC0aF1c72924af7502b';

// https://basescan.org/address/0x8D9e0911A532e2a3C005667B475E6F9742355f2b
export const SVR_BTC__USD_BASE = '0x8D9e0911A532e2a3C005667B475E6F9742355f2b';

// https://basescan.org/address/0xF5f4A4de107a46f25CDf08529144B48448dc2f83
export const AAVE_SVR_rsETH__ETH_Exchange_Rate = '0xF5f4A4de107a46f25CDf08529144B48448dc2f83';

// https://basescan.org/address/0xAc0a5bB171350536207245afB0EB269b8195501B
export const AAVE_SVR_rsETH__ETH_Exchange_Rate_BASE = '0xAc0a5bB171350536207245afB0EB269b8195501B';

// https://basescan.org/address/0xBD867487712ADeC5A59b9Ae475Ee942f652B4C91
export const swBTC__WBTC_Exchange_Rate = '0xBD867487712ADeC5A59b9Ae475Ee942f652B4C91';

// https://basescan.org/address/0xAa98aE504658766Dfe11F31c5D95a0bdcABDe0b1
export const RSR__USD = '0xAa98aE504658766Dfe11F31c5D95a0bdcABDe0b1';

// https://basescan.org/address/0x2621897C993fdE08873Ef58dA1453aEE49a70144
export const LsETH__ETH_Exchange_Rate = '0x2621897C993fdE08873Ef58dA1453aEE49a70144';

export const CHAIN_ID = 8453;
